module.exports = __webpack_public_path__ + "static/media/RUSSELL K. RED 100 LOUDSPEAKERS.17409ff0.png";